<template>
  <div>
    <v-navigation-drawer
      class="elevation-5"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      left
    >
      <v-list dense nav class="mr-2">
        <template v-for="(item, index) in desserts">
          <v-list-group
            class="ma-0"
            v-if="
              item.children.length > 0 &&
              Fn_checkIncludesRole(item.RoleAccess, item.ShowSetting) === true
            "
            :key="index"
            v-model="item.model"
            :disabled="item.disable"
            :append-icon="item.model ? item.action : item['icon-alt']"
            color="#077893"
          >
            <template v-slot:activator>
              <v-list-item-action class="ma-0">
                <!-- <v-avatar color="#077893" size="30" tile class="rounded-lg"> -->
                <v-icon light color="#077893">{{ item.icon }}</v-icon>
                <!-- </v-avatar> -->
              </v-list-item-action>
              <!-- <v-list-item-content class="ml-2"> -->
              <v-list-item-title class="ml-2">
                <b style="font-size: 13px; color: #077893">{{
                  $t(item.text)
                }}</b>
              </v-list-item-title>
              <!-- </v-list-item-content> -->
            </template>

            <!-- for item in children -->
            <div v-for="(child, i) in item.children" :key="i">
              <v-list-item
                v-if="
                  child.group === false &&
                  Fn_checkIncludesChildRole(
                    child.RoleAccess,
                    child.ShowSetting
                  ) === true
                "
                link
                :to="child.to"
                :disabled="child.disable"
                color="#077893"
              >
                <!-- <v-list-item-action style="color: #077893"></v-list-item-action> -->
                <v-list-item-content class="ml-7">
                  <v-list-item-title
                    class="pa-1"
                    style="color: #077893; font-size: 13px"
                    :inner-text.prop="$t(child.text)"
                  >
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon
                    color="#077893"
                    :inner-text.prop="child.icon"
                  ></v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-list-group
                v-if="
                  child.group === true &&
                  Fn_checkIncludesChildRole(
                    child.RoleAccess,
                    child.ShowSetting
                  ) === true
                "
                sub-group
                color="#077893"
                :disabled="child.disable"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      class="pa-0"
                      style="color: #077893; font-size: 13px"
                      ><b>{{ $t(child.text) }}</b>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon
                      color="#077893"
                      :inner-text.prop="child.icon"
                    ></v-icon>
                  </v-list-item-action>
                </template>
                <div v-for="(a, l) in child.list" :key="l + 'a'">
                  <v-list-item
                    v-if="
                      Fn_checkIncludesListRole(a.RoleAccess, a.ShowSetting) ===
                      true
                    "
                    link
                    :disabled="a.disable"
                    :to="a.to"
                    color="#077893"
                  >
                    <!-- <v-list-item-action>
                        <v-icon color="#077893">{{ a.icon }}</v-icon>
                      </v-list-item-action> -->
                    <v-list-item-content class="ml-5">
                      <v-list-item-title
                        class="pa-1"
                        style="color: #077893; font-size: 13px"
                        >{{ $t(a.text) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list-group>
            </div>
          </v-list-group>

          <v-list-item
            v-if="
              item.children.length == 0 &&
              Fn_checkIncludesRole(item.RoleAccess) === true
            "
            :key="index"
            link
            :to="item.to"
            :disabled="item.disable"
            color="#077893"
          >
            <!-- <v-list-item-action>
                  <v-avatar color="#077893" size="30" tile class="rounded-lg">
                    <v-icon small color="white">{{ item.icon }}</v-icon>
                  </v-avatar>
                </v-list-item-action> -->
            <v-list-item-content class="ml-5">
              <v-list-item-title>
                <b style="font-size: 14px;color">{{ $t(item.text) }}</b>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="#077893"
      class="elevation-5"
      outlined
      :scroll-threshold="1"
    >
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        dark
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="ml-0 pa-0 mt-0">
        <img
          class="d-sm-flex d-none"
          :src="require('@/assets/img/logoCMPWhite.png')"
          width="150"
        />
      </v-toolbar-title>
      <v-layout row wrap justify-center align-center mt-3>
        <v-flex xs9 lg9 class="pointer">
          <v-autocomplete
            style="color: #077893"
            v-if="$t('default') === 'th'"
            return-object
            dark
            :label="$t('Profile.companyname')"
            outlined
            dense
            :loading="LoadingBusiness"
            item-text="BusinessNameTH"
            item-value="BusinessId"
            :items="ItemsBusiness"
            v-model="SelectBusiness"
            @change="Fn_SelectBusiness"
          >
          </v-autocomplete>
          <v-autocomplete
            v-else
            return-object
            dark
            :label="$t('Profile.companyname')"
            outlined
            dense
            color="white"
            item-text="BusinessNameEng"
            item-value="BusinessId"
            :items="ItemsBusiness"
            v-model="SelectBusiness"
            @change="Fn_SelectBusiness"
          >
          </v-autocomplete>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>

      <v-layout row wrap align-end justify-end class="d-md-flex d-none">
        <v-flex xs2 lg2 class="text-end">
          <img
            class="rounded-circle"
            :src="require('@/assets/img/thailand.png')"
            width="25"
            v-if="$t('default') === 'th'"
          />
          <img
            class="rounded-circle"
            :src="require('@/assets/img/united-kingdom.png')"
            width="25"
            v-if="$t('default') === 'en'"
          />
        </v-flex>
        <!-- <v-flex xs3 lg1 class="white--text fontSize" @click="fn_changelanguage('th')">
              TH</v-flex>
            &nbsp;&nbsp;&nbsp;<v-divider inset vertical color="white" class="mt-2"></v-divider>
            <v-flex xs3 lg1 class="white--text ml-6 fontSize" @click="fn_changelanguage('en')">
              EN</v-flex>
            <v-flex xs2 lg1 class="white--text mr-2"></v-flex> -->
        <v-btn
          dense
          text
          dark
          class="font-weight-bold"
          @click="fn_changelanguage('th')"
          >TH</v-btn
        >
        <v-divider vertical color="white"></v-divider>
        <v-btn
          dense
          text
          dark
          class="font-weight-bold"
          @click="fn_changelanguage('en')"
          >EN</v-btn
        >
      </v-layout>
      &nbsp;&nbsp;
      <v-divider inset vertical color="white"></v-divider>
      <v-menu
        class="hidden-sm-and-down"
        :close-on-content-click="false"
        offset-y
        bottom
        open-on-hover
        transition="slide-y-transition"
        max-width="300"
      >
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            <v-icon class="mr-2" color="white">mdi-account-outline</v-icon>
            <span class="hidden-sm-and-down white--text"
              >&nbsp; {{ Username }}
            </span>
            <v-icon color="white">mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-list dense>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon color="#077893" x-large>mdi-account-outline</v-icon>
              </v-list-item-avatar>

              <v-list-item-content class="text-left">
                <v-list-item-title class="pb-1" style="color: #077893">
                  {{ $t("Profile.username") }}
                </v-list-item-title>
                <v-list-item-subtitle style="color: #077893">
                  {{ Username }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item to="/profile">
              <v-list-item-avatar> </v-list-item-avatar>
              <v-list-item-content class="text-left">
                <v-list-item-title class="pb-1" style="color: #077893">
                  {{ $t("Toolbar.general") }}</v-list-item-title
                >
              </v-list-item-content>
              <v-list-item-avatar>
                <v-icon color="#077893">mdi-account-outline</v-icon>
              </v-list-item-avatar>
            </v-list-item>
            <v-list-item @click="Fn_logout">
              <v-list-item-avatar> </v-list-item-avatar>
              <v-list-item-content class="text-left">
                <v-list-item-title class="pb-1" style="color: #077893">
                  {{ $t("Toolbar.logout") }}</v-list-item-title
                >
              </v-list-item-content>
              <v-list-item-avatar>
                <v-icon color="#077893">mdi-logout-variant</v-icon>
              </v-list-item-avatar>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
    <div v-if="loadingDownloadData">
      <OverlaySearch />
    </div>
  </div>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { OverlaySearch },
  props: {
    source: String,
  },
  data: () => ({
    loadingDownloadData: false,
    LoadingBusiness: false,
    drawer: null,
    SelectBusiness: "00000",
    BusinessId: "00000",
    Timestamps: "",
    RoleAccount: "",
    DataBusiness: [],
    ItemsBusiness: [],
    ItemsRole: [],
    ItemsNewRole: [],
    AllMenu: [],
  }),
  async mounted() {
    if (this.$cookies.isKey("BusinessSelect") === true) {
      this.SelectBusiness = this.$cookies.get("BusinessSelect");
    } else {
      this.$cookies.set("BusinessId", "00000");
    }
    this.fn_getBusiness();
  },
  computed: {
    ...mapGetters(["StatusBusiness"]),
    _StatusBusiness: {
      get() {
        return this.StatusBusiness;
      },
    },
    Username: {
      get() {
        return this.$cookies.get("OneUsername") || "-";
      },
    },
    AccountId: {
      get() {
        return this.$cookies.get("OneAccountId") || "-";
      },
    },
    desserts: {
      get() {
        return this.$store.state.MenuToolbarDefault;
      },
    },
    DataCheckRole: {
      get() {
        return this.$store.state.DataCheckRole;
      },
    },
  },
  methods: {
    Fn_checkIncludesRole(val, show) {
      if (this.DataCheckRole.length > 0) {
        for (var item in this.DataCheckRole) {
          const CheckRole = val.includes(this.DataCheckRole[item]);
          if (CheckRole === true) {
            return true;
          } else if (val.length === 0) {
            return true;
          }
        }
        return false;
      } else if (
        this.DataCheckRole.length === 0 &&
        this.$cookies.get("BusinessId") === "00000"
      ) {
        return true;
      } else if (this.DataCheckRole.length === 0 && show === true) {
        return false;
      } else {
        return true;
      }
    },
    Fn_checkIncludesChildRole(child, show) {
      if (this.DataCheckRole.length > 0) {
        for (var item in this.DataCheckRole) {
          const CheckRole = child.includes(this.DataCheckRole[item]);
          if (CheckRole === true) {
            return true;
          } else if (child.length === 0) {
            return true;
          }
        }
        return false;
      } else if (
        this.DataCheckRole.length === 0 &&
        this.$cookies.get("BusinessId") === "00000"
      ) {
        return true;
      } else if (this.DataCheckRole.length === 0 && show === true) {
        return false;
      } else {
        return true;
      }
    },
    Fn_checkIncludesListRole(list, show) {
      if (this.DataCheckRole.length > 0) {
        for (var item in this.DataCheckRole) {
          const CheckRole = list.includes(this.DataCheckRole[item]);
          if (CheckRole === true) {
            return true;
          } else if (list.length === 0) {
            return true;
          }
        }
        return false;
      } else if (
        this.DataCheckRole.length === 0 &&
        this.$cookies.get("BusinessId") === "00000"
      ) {
        return true;
      } else if (this.DataCheckRole.length === 0 && show === true) {
        return false;
      } else {
        return true;
      }
    },
    // fn_getTimestamps () {
    //   this.axios
    //     .get(process.env.VUE_APP_API_FACTORING_SERVICE + 'timestamp/')
    //     .then((response) => {
    //       if (response.data.Status === 'OK') {
    //         this.Timestamps = response.data.Message.TimeStamp
    //         this.$cookies.set('Timestamps', this.Timestamps)
    //         // this.fn_getAllRole();
    //       } else {
    //         Toast.fire({
    //           icon: 'error',
    //           title: response.data.ErrorMessage
    //         })
    //       }
    //     })
    //     .catch((error) => {
    //       if (error.response) {
    //         Toast.fire({
    //           icon: 'error',
    //           title: error.response.data.ErrorMessage
    //         })
    //       } else if (error.request) {
    //         Toast.fire({
    //           icon: 'error',
    //           title: error.request
    //         })
    //       } else {
    //         Toast.fire({
    //           icon: 'error',
    //           title: error.message || error
    //         })
    //       }
    //     })
    // },
    async fn_getBusiness() {
      var payload = {
        UserName: this.$cookies.get("OneUsername"),
        AccountId: this.$cookies.get("OneAccountId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "business/GetAllBusiness",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loading = false;

          if (response.data.Status === "OK") {
            this.ItemsBusiness = response.data.Message;
            this.$store.dispatch("SET_ALLBUSINESS", this.ItemsBusiness);
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    // fn_getAllRole() {
    //   var payload = {
    //     TimeStamp: this.Timestamps,
    //   };
    //   this.axios
    //     .post(
    //       process.env.VUE_APP_API_FACTORING_SERVICE + "admin/AllRole",
    //       payload
    //     )
    //     .then((response) => {
    //       this.loading = false;

    //       if (response.data.Status === "OK") {
    //         this.ItemsRole = response.data.Message[0];
    //         for (var i in this.ItemsRole) {
    //           var ArrayRole = this.ItemsRole[i].role_name;
    //           this.ItemsNewRole.push(ArrayRole);
    //           this.$store.dispatch("SET_ALLROLE", this.ItemsNewRole);
    //         }
    //       } else {
    //         Toast.fire({
    //           icon: "error",
    //           title: response.data.ErrorMessage,
    //         });
    //       }
    //     })
    //     .catch((error) => {
    //       if (error.response) {
    //         Toast.fire({
    //           icon: "error",
    //           title: error.response.data.ErrorMessage,
    //         });
    //       } else if (error.request) {
    //         Toast.fire({
    //           icon: "error",
    //           title: error.request,
    //         });
    //       } else {
    //         Toast.fire({
    //           icon: "error",
    //           title: error.message || error,
    //         });
    //       }
    //     });
    // },
    async fn_getMenuDefault() {
      var payload = {
        AccessToken: this.$cookies.get("OneAccessToken"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "config-notify/MenuUserDefault",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.Status === "OK") {
            this.AllMenu = response.data.Message.ForFront[0].menu;
            this.$store.dispatch(
              "GET_ROLE_ACCESS",
              response.data.Message.RoleAccess
            );
            if (this.$cookies.get("BusinessId") === "00000") {
              this.$store.dispatch("GET_MENU_DEFAULT", [this.AllMenu[0]]);
            } else {
              this.$store.dispatch("GET_MENU_DEFAULT", this.AllMenu);
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    fn_changelanguage(language) {
      this.loadingDownloadData = true;
      if (language === "th") {
        setTimeout(() => (this.loadingDownloadData = false), 300);
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
      } else if (language === "en") {
        setTimeout(() => (this.loadingDownloadData = false), 300);
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
      }
    },
    Fn_logout() {
      this.$cookies.remove("OneUsername");
      this.$cookies.remove("OneAccountId");
      this.$cookies.remove("OneAccessToken");
      this.$cookies.remove("OneRefreshToken");
      this.$cookies.remove("Timestamps");
      this.$cookies.remove("RoleAccount");
      this.$cookies.remove("BusinessSelect");
      this.$cookies.remove("BusinessId");
      this.$cookies.remove("CheckAdminName");
      this.$cookies.remove("RoleAccountId");
      localStorage.removeItem("BusinessNameTH");
      localStorage.removeItem("BusinessNameEng");
      localStorage.removeItem("OneTaxId");
      localStorage.removeItem("lang");
      var PathUrl =
        process.env.VUE_APP_PATH_LOGOUT_ONEID + process.env.VUE_APP_PATH_LOCAL;
      window.location.href = PathUrl;
    },
    async Fn_SelectBusiness() {
      if (this.SelectBusiness.BusinessId !== "00000") {
        var payload = {
          AccessToken: this.$cookies.get("OneAccessToken"),
          BusinessId: this.SelectBusiness.BusinessId,
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE + "business/InsertDept",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {})
          .catch((error) => {});
      }

      // if (this._StatusBusiness === true) {
      window.location.reload();
      // this.Fn_SyncBusiness()
      // }
    },
    // async Fn_SyncBusiness () {
    //   var payload = {
    //     AccessToken: this.$cookies.get('OneAccessToken'),
    //     BusinessId: this.SelectBusiness.BusinessId,
    //     AccountId: this.$cookies.get('OneAccountId')
    //   }
    //   var Headers = {
    //     AccountId: this.$cookies.get('OneAccountId')
    //   }
    //   var dataEncode = await authorization.encodeDataNew(payload)
    //   var auth = await authorization.encodeDataNew(Headers)
    //   var headers = { Authorization: 'Bearer ' + auth }
    //   this.axios
    //     .post(
    //       process.env.VUE_APP_API_FACTORING_SERVICE + 'business/SyncBusiness',
    //       { Data: dataEncode },
    //       { headers }
    //     )
    //     .then((response) => {
    //       if (response.data.Status === 'OK') {
    //         console.log(response.data)
    //       } else {
    //         Toast.fire({
    //           icon: 'error',
    //           title: response.data.ErrorMessage
    //         })
    //       }
    //     })
    //     .catch((error) => {
    //       if (error.response) {
    //         Toast.fire({
    //           icon: 'error',
    //           title: error.response.data.ErrorMessage
    //         })
    //       } else if (error.request) {
    //         Toast.fire({
    //           icon: 'error',
    //           title: error.request
    //         })
    //       } else {
    //         Toast.fire({
    //           icon: 'error',
    //           title: error.message || error
    //         })
    //       }
    //     })
    // }
  },
  watch: {
    SelectBusiness: function (val) {
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: val.BusinessId,
        AccessToken: this.$cookies.get("OneAccessToken"),
        Token: val.Token,
        TaxId: val.TaxId,
        UpdatdeAt: val.UpdatdeAt,
        BusinessNameTH: val.BusinessNameTH,
        BusinessNameEng: val.BusinessNameEng,
      };
      this.$cookies.set("BusinessSelect", payload);
      this.$cookies.set("BusinessId", val.BusinessId);
      this.$cookies.set("TaxIdCMP", val.TaxId);
      this.$store.dispatch("SET_BUSINESS", this.SelectBusiness);
      // this.$store.dispatch('SET_MENU')
    },
  },
};
</script>
<style>
.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
  margin-right: 14px;
}

.v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
  margin-left: 4px;
}

.v-input__slot,
input#input-18,
.flex.white--text.fontSize.xs3.lg1,
.pointer,
input#input-27 {
  cursor: pointer !important;
}
</style>
